'use client';

import { c as _c } from "react/compiler-runtime";
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import { FadeUp } from '@algoacademy/design-system/web/marketing/animation/FadeUp';
import { MarginsLayout } from '@algoacademy/design-system/web/marketing/layouts/Margins';
import { ScrollSpyLayout, type Section } from '@algoacademy/design-system/web/marketing/layouts/ScrollSpy';
import { QAComplaintSection } from './_sections/QAComplaint';
import { QAInvoiceSection } from './_sections/QAInvoice';
import { QAKnowledgeDbSection } from './_sections/QAKnowledgeDb';
import { QAMentoringSection } from './_sections/QAMentoring';
import { QAOtherSection } from './_sections/QAOther';
import { QuestionsAndAnswersSection } from './_sections/QuestionsAndAnswers';
import { TopSection } from './_sections/Top/Top';
const sectionData: {
  title: string;
  component: React.ComponentType;
}[] = [{
  title: 'Mentoring',
  component: QAMentoringSection
}, {
  title: 'Baza wiedzy',
  component: QAKnowledgeDbSection
}, {
  title: 'Reklamacje',
  component: QAComplaintSection
}, {
  title: 'Faktury i płatności',
  component: QAInvoiceSection
}, {
  title: 'Inne',
  component: QAOtherSection
}];
export default function Faq() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = sectionData.map(_temp);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const sections = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MarginsLayout><FadeUp><TopSection /></FadeUp><VerticalSpacer size="articleSection" /><ScrollSpyLayout sections={sections} /></MarginsLayout>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(item, idx) {
  return {
    id: idx,
    title: item.title,
    content: <FadeUp><QuestionsAndAnswersSection title={item.title}><item.component />{idx < sectionData.length - 1 && <VerticalSpacer size="section" />}</QuestionsAndAnswersSection></FadeUp>
  };
}